import { AxiosPromise } from 'axios';
import { DataResponse, ProfileData } from '@/types';
import api from '@/repositories/api';

export default {
  get(): AxiosPromise<DataResponse<ProfileData>> {
    return api.get('/me');
  },
};
